import 'whatwg-fetch';
import {queryString} from 'utilities/url';
import {notifyFetchErrors} from '../../../../utilities/fetch';
import {encodeJsonURI} from '../../../../services/jsonp';
import getCSRFToken from '../../../../utilities/security/token-fetcher';

const BASE_URI = '/services_marketplace/workflow';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': getCSRFToken(),
};
const options = {
  headers,
  credentials: 'same-origin',
};

/**
 * This function gives us an easy way to integrate
 * into the `fetch` call and populate the appropriate
 * cache with the response.
 *
 * @param cache
 * @param key
 * @returns {function(*)}
 */
function updateCache(cache, key) {
  return response => {
    cache[key] = response;
    return response;
  };
}

/* eslint-disable camelcase */
export function getStep(step_handle, input_handle, input_value) {
  const params = encodeJsonURI({step_handle, input_handle, input_value});
  const URL = `${BASE_URI}/step?${params}`;

  return fetch(URL, options)
    .then(
      notifyFetchErrors('ServicesMarketplace::StepSubmitRejected', {
        step_handle,
        input_handle,
        input_value,
      })
    )
    .then(response => response.json());
}

export function getServiceStep(service_handle) {
  const params = encodeJsonURI({service_handle});
  const URL = `${BASE_URI}/step?${params}`;

  return fetch(URL, options)
    .then(
      notifyFetchErrors('ServicesMarketplace::ServiceStepSubmitRejected', {
        service_handle,
      })
    )
    .then(response => response.json());
}

const _getQuestionCache = {};
export function getQuestions(input_handle, input_value) {
  const cacheKey = `${input_handle}-${input_value}`;

  if (_getQuestionCache[cacheKey]) {
    return Promise.resolve(_getQuestionCache[cacheKey]);
  } else {
    const params = queryString.stringify(
      {input_handle, input_value},
      {arrayFormat: 'bracket'}
    );
    const URL = `${BASE_URI}/questions?${params}`;

    return fetch(URL, options)
      .then(
        notifyFetchErrors('ServicesMarketplace::QuestionFetchRejected', {
          input_handle,
          input_value,
        })
      )
      .then(response => response.json())
      .then(updateCache(_getQuestionCache, cacheKey));
  }
}
/* eslint-enable camelcase */
